import { useTranslation } from 'react-i18next'

import { Radio, ToggleGroup } from '@/design-system'
import { OuiNon } from '@/domaine/OuiNon'
import { useSelection } from '@/hooks/UseSelection'
import { NoOp } from '@/utils/NoOp'

interface OuiNonInputProps {
	id: string
	value?: OuiNon
	onChange?: (value: OuiNon | undefined) => void

	aria?: {
		labelledby?: string
		describedby?: string
	}
}

export function OuiNonInput({
	id,
	value,
	onChange = NoOp,
	aria,
}: OuiNonInputProps) {
	const { handleChange, currentSelection } = useSelection({
		value,
		onChange,
	})

	const handleToggleGroupChange = (value: string | undefined) => {
		handleChange(value as OuiNon | undefined)
	}
	const currentValueAsString =
		currentSelection === undefined
			? undefined
			: currentSelection === 'oui'
				? 'oui'
				: 'non'

	const { t } = useTranslation()

	return (
		<ToggleGroup
			aria-label=""
			aria-labelledby={aria?.labelledby}
			aria-describedby={aria?.describedby}
			onChange={handleToggleGroupChange}
			value={currentValueAsString}
		>
			<Radio value="oui" id={`input-oui-${id || ''}`}>
				{t('conversation.yes', 'Oui')}
			</Radio>
			<Radio value="non" id={`input-non-${id || ''}`}>
				{t('conversation.no', 'Non')}
			</Radio>
		</ToggleGroup>
	)
}
